module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001344.f06ba2eb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001344.pdf
// module id = 346
// module chunks = 0